import {css} from "@panda/css";

export const wizardTextInputRules = css.raw({
    border: "1px solid var(--colors-gray-900)",
    pb: "2.15rem",
    pl: 2,
    pr: 1,
    pt: "2.15rem"
});

export const wizardTextInputStyle = css(wizardTextInputRules);

export const wizardTextInputChildStyle = css({
    "& > div": wizardTextInputRules
});
import {css} from "@panda/css";

export const wizardTextInputRules = css.raw({
    border: "1px solid var(--colors-gray-900)",
    pb: "2.15rem",
    pl: 2,
    pr: 1,
    pt: "2.15rem"
});

export const wizardTextInputStyle = css(wizardTextInputRules);

export const wizardTextInputChildStyle = css({
    "& > div": wizardTextInputRules
});
